import React, {
    createContext,
    useContext,
    useMemo,
    useState,
} from "react";

const ClassroomContext = createContext(null);

export function ClassroomProvider({ children }) {
    /*
        Lesson
    */

    const [activeLesson, setActiveLesson] =
        useState(null);

    const [activeSection, setActiveSection] =
        useState(null);

    /*
        Lesson Stage
    */

    const [stageMode, setStageMode] =
        useState("lesson");

    const [splitTool, setSplitTool] =
        useState(null);
    
    const [stageItem, setStageItem] =
        useState(null);

    /*
        Workspace
    */

    const [workspaceTab, setWorkspaceTab] =
        useState("notebook");

    /*
        Notebook
    */

    const [notebookOpen, setNotebookOpen] =
        useState(true);

    /*
        Whiteboard
    */

    const [whiteboardOpen, setWhiteboardOpen] =
        useState(true);

    /*
        Workspace folders
    */

    const [workspaceFolders, setWorkspaceFolders] =
        useState([]);

    /*
        Layout
    */

    const [layout, setLayout] =
        useState({
            workspaceWidth: 420,
            showWorkspace: true,
            showLessonStage: true,
            showGadgets: true,
        });

    const value = useMemo(
        () => ({
            activeLesson,
            setActiveLesson,

            activeSection,
            setActiveSection,

            stageMode,
            setStageMode,

            splitTool,
            setSplitTool,

            workspaceTab,
            setWorkspaceTab,

            notebookOpen,
            setNotebookOpen,

            whiteboardOpen,
            setWhiteboardOpen,

            workspaceFolders,
            setWorkspaceFolders,

            layout,
            setLayout,

            stageItem,
            setStageItem,
        }),
        [
            activeLesson,
            activeSection,
            stageMode,
            splitTool,
            workspaceTab,
            notebookOpen,
            whiteboardOpen,
            workspaceFolders,
            layout,
            stageItem,
        ]
    );

    return (
        <ClassroomContext.Provider value={value}>
            {children}
        </ClassroomContext.Provider>
    );
}

export function useClassroom() {
    const context =
        useContext(ClassroomContext);

    if (!context) {
        throw new Error(
            "useClassroom must be used inside ClassroomProvider."
        );
    }

    return context;
}